module.exports = __webpack_public_path__ + "static/oyenusi-459624ec8561b29dea1ea4bc861033e0.jpg";